var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloomIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.82 0C4.37744 0 5.64 1.26256 5.64 2.82V4.08C5.64 5.33921 6.66079 6.36 7.92 6.36H9.18C10.7374 6.36 12 7.62256 12 9.18C12 10.7374 10.7374 12 9.18 12C7.62256 12 6.36 10.7374 6.36 9.18V7.92C6.36 6.66079 5.33921 5.64 4.08 5.64H2.82C1.26256 5.64 0 4.37744 0 2.82C0 1.26256 1.26256 0 2.82 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.52 2.82C11.52 4.11235 10.4723 5.16 9.18 5.16C7.88765 5.16 6.84 4.11235 6.84 2.82C6.84 1.52765 7.88765 0.48 9.18 0.48C10.4723 0.48 11.52 1.52765 11.52 2.82Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82 11.52C4.11235 11.52 5.16 10.4723 5.16 9.18C5.16 7.88765 4.11235 6.84 2.82 6.84C1.52765 6.84 0.48 7.88765 0.48 9.18C0.48 10.4723 1.52765 11.52 2.82 11.52Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloomIconSmall);
export default __webpack_public_path__ + "static/media/bloomIconSmall.8a2257d00704a37f9cc98b03af2c749d.svg";
export { ForwardRef as ReactComponent };